import { render, staticRenderFns } from "./MenuActions.vue?vue&type=template&id=547f1e22&scoped=true"
import script from "./MenuActions.vue?vue&type=script&lang=js"
export * from "./MenuActions.vue?vue&type=script&lang=js"
import style0 from "./MenuActions.vue?vue&type=style&index=0&id=547f1e22&prod&lang=scss&scoped=true"
import style1 from "./MenuActions.vue?vue&type=style&index=1&id=547f1e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f1e22",
  null
  
)

export default component.exports